import { About } from "~landing/components/about/about";
import { Layout } from "~landing/components/layout";

export function AboutUs() {
	return (
		<Layout>
			<main>
				<About />
			</main>
		</Layout>
	);
}
